// @flow

import jobs from './apis/jobs';
import savedSearches from './apis/savedSearches';
import jobdetails from './apis/jobdetails';
import locations from './apis/locations';
import candidate from './apis/candidate';
import lmis from './apis/lmis';
import { putToEventCapture } from './apis/eventCapture';

export default () => {
  return {
    jobdetails,
    jobs,
    savedSearches,
    locations,
    candidate,
    lmis,
    eventCapture: {
      putToEventCapture
    }
  };
};
